/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"
import PercentageBox from "./percentage_box"
import PreviewPill from "./preview_pill"
import ProgressBadge from "./progress_badge"
import StudySummaryModal from "./study_summary_modal"
import {use_modal} from "../../modal_provider"

function LastStudySession({
  stats,
  open_quiz_mode_modal,
  full_mastery,
  can_train
}) {
  const {open_modal} = use_modal()
  const last_study_session_in_words = stats.last_study_session_in_words
  const accumulated_content_discovered = stats.accumulated_content_discovered
  const content_discovered = stats.content_discovered
  const average_knowledge_change = stats.average_knowledge_change
  const learnables = stats.learnables_progress

  return (
    <div className="last-session-stats-container">
      <p className="last-session-text">
        {I18n.t("js.embedded_quiz.study_summary.last_session")}
        {" · "}
        {I18n.t("js.embedded_quiz.time_ago",
          {time: last_study_session_in_words})}
      </p>
      {!full_mastery && <>
        <div className="percentage-boxes">
          <PercentageBox
            color={"blue"}
            number={accumulated_content_discovered}
            text={<>
              <ProgressBadge change={content_discovered}/>
              {I18n.t("js.embedded_quiz.study_summary.content_discovered")}
            </>}
          />
          <PercentageBox
            color={average_knowledge_change >= 0 ? "green" : "red"}
            number={Math.abs(average_knowledge_change)}
            text=
              {I18n.t("js.embedded_quiz.study_summary.knowledge_increase")}
          />
        </div>
        {!can_train && <PreviewPill/>}
      </>}
      {full_mastery && <div className="percentage-box percentage-box--gold">
        <div className="figure">
          <FaIcon name={"fa-star"}/>
          100
          <span className="percentage">%</span>
        </div>
        <div className="label">
          {I18n.t("js.embedded_quiz.study_summary.mastery")}
        </div>
        {!can_train && <PreviewPill/>}
        {can_train && <div className="cta-text">
          <div>
            {I18n.t("js.embedded_quiz.study_summary.ready_to_test")}
          </div>
          <button
            className="btn btn-link"
            onClick={() => open_quiz_mode_modal("exam_mode", full_mastery)}
          >
            {I18n.t("js.embedded_quiz.study_summary.start_exam_quiz")}
            <FaIcon name={"fa-arrow-right"}/>
          </button>
        </div>}
      </div>}
      <div>
        <button className="show-detailed btn btn-link"
                onClick={() => open_modal("study_summary")}>
          {I18n.t("js.embedded_quiz.study_summary.show_detailed")}
        </button>
        <StudySummaryModal
          learnables={learnables}
          average_knowledge_change={average_knowledge_change}
        />
      </div>
    </div>
  )
}

export default LastStudySession
